<template>
  <div>
    <section>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <hero-bar :has-right-visible="true"> <b-icon icon="mdi mdi-bank" type="is-primary" size="is-medium"></b-icon> Bank Details </hero-bar>
          </div>
        </div>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <form autocomplete="off" @submit.prevent="saveBankDetails()" name="bankDeatils">
        <card-component>
          <div class="column"></div>

          <div class="column is-8 ">
            <table class="table is-fullwidth ">
              <tr>
                <th><b-icon icon="mdi mdi-store" type="is-primary" size="is-medium"></b-icon></th>
                <td><drop-down type="forFranchiseeSelection"></drop-down></td>
              </tr>

              <tr>
                <th>Razor Pay ID:</th>
                <td><input class="input" type="text" v-model="razorpayAccountID" /></td>
              </tr>

              <tr>
                <th>Bank Name:</th>
                <td><input class="input" type="text" v-model="bankName" /></td>
              </tr>

              <tr>
                <th>Bank Branch Name:</th>
                <td><input class="input" type="text" v-model="bankBranchName" /></td>
              </tr>
              <tr>
                <th>Category:</th>
                <td><input class="input" type="text" v-model="category" /></td>
              </tr>
              <tr>
                <th>Account No:</th>
                <td><input class="input" type="number" v-model="accountNo" /></td>
              </tr>
              <tr>
                <th>Short Name:</th>
                <td><input class="input" type="text" v-model="shortName" /></td>
              </tr>
              <tr>
                <th>IFSC Code :</th>
                <td><input class="input" type="text" v-model="ifscCode" /></td>
              </tr>
              <tr>
                <th>Bank CMS Code:</th>
                <td><input class="input" type="text" v-model="bankCMSCode" /></td>
              </tr>
              <tr>
                <th>Beneficiary Name:</th>
                <td><input class="input" type="text" v-model="beneficiaryName" /></td>
              </tr>

              <tr>
                <th>Cheque Bounce charges:</th>
                <td><input class="input" type="text" v-model="chequeBounceCharges" /></td>
              </tr>
              <tr>
                <th>Logo:</th>
                <td>
                  <div class="control select is-fullwidth">
                    <select v-model="logo">
                      <option value="">---Select---</option>
                      <option value="STATE BANK OF INDIA">STATE BANK OF INDIA</option>
                      <option value="BANK OF INDIA">BANK OF INDIA</option>
                    </select>
                  </div>
                </td>
              </tr>

              <tr>
                <th>This Account is used for:</th>
                <td>
                  <b-switch v-model="isActive">Is Active</b-switch>
                  <b-switch v-model="isDepositFee">To deposite Fee Collection</b-switch>
                  <b-switch v-model="isExpenses">Expenses/Payments</b-switch>
                  <b-switch v-model="isFeeChallan">Is Fee Challan Account</b-switch>
                </td>
              </tr>
            </table>
          </div>

          <footer class="column has-text-right">
            <button class="button is-success" type="submit">Save</button>
          </footer>
        </card-component>
      </form>
    </section>
  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import HeroBar from '@/components/template/HeroBar'
import store from '@/store'
import constants from '@/utils/constants'
import DropDown from '../../components/reusableComp/dropDown'
export default {
  props: ['id'],
  components: {
    HeroBar,
    CardComponent,
    DropDown
  },
  data () {
    return {
      category: '',
      isActive: true,
      isDepositFee: false,
      isExpenses: false,
      isFeeChallan: false,
      bankBranchName: '',
      bankName: '',
      accountNo: '',
      shortName: '',

      razorpayAccountID: '',
      ifscCode: '',
      bankCMSCode: '',
      beneficiaryName: '',
      chequeBounceCharges: '',
      logo: ''
    }
  },
  computed: {
    franchiseeID: {
      get () {
        return store.state.feeComponent.franchiseeID
      },
      set (value) {
        store.commit('updateFranchiseeID', value)
      }
    }
  },
  async created () {
    if (this.id) {
      await this.onStart()
    } else {
      this.franchiseeID = ''
    }
  },
  methods: {
    onStart: async function () {
      if (this.id) {
        try {
          this.loadingComponent = this.$buefy.loading.open()
          const { data } = await http.get(`${constants.API_URL}/api/franchisee-bank-details/${this.id}`)
          this.category = data.category
          this.isActive = data.isActive
          this.isDepositFee = data.isDepositFee
          this.isExpenses = data.isExpenses
          this.isFeeChallan = data.isFeeChallan
          this.bankBranchName = data.bankBranchName
          this.bankName = data.bankName
          this.accountNo = data.accountNo
          this.shortName = data.shortName
          this.franchiseeID = data.franchiseeID
          this.razorpayAccountID = data.razorpayAccountID
          this.ifscCode = data.ifscCode
          this.bankCMSCode = data.bankCMSCode
          this.beneficiaryName = data.beneficiaryName
          this.chequeBounceCharges = data.chequeBounceCharges
          this.logo = data.logo
          this.loadingComponent.close()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      }
    },
    saveBankDetails: async function () {
      let formData = {
        category: this.category,
        isActive: this.isActive,
        isDepositFee: this.isDepositFee,
        isExpenses: this.isExpenses,
        isFeeChallan: this.isFeeChallan,
        bankBranchName: this.bankBranchName,
        bankName: this.bankName,
        accountNo: this.accountNo,
        shortName: this.shortName,
        franchiseeID: this.franchiseeID,
        razorpayAccountID: this.razorpayAccountID,
        ifscCode: this.ifscCode,
        bankCMSCode: this.bankCMSCode,
        beneficiaryName: this.beneficiaryName,
        chequeBounceCharges: this.chequeBounceCharges,
        logo: this.logo
      }
      if (!this.id) {
        try {
          this.loadingComponent = this.$buefy.loading.open()
          await http.post(`${constants.API_URL}/api/franchisee-bank-details`, formData)
          this.$router.push({ name: 'BankDetailsList' })
          this.$buefy.dialog.alert({
            type: 'is-success',
            message: 'Saved successfully',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.loadingComponent.close()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } else {
        try {
          this.loadingComponent = this.$buefy.loading.open()
          await http.put(`${constants.API_URL}/api/franchisee-bank-details/${this.id}`, formData)
          this.$router.push({ name: 'BankDetailsList' })
          this.$buefy.dialog.alert({
            type: 'is-success',
            message: 'Updated successfully',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
          this.loadingComponent.close()
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.loadingComponent.close()
          return this.$buefy.dialog.alert({
            type: 'is-danger',
            message: errorMessage,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',

            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      }
    }
  }
}
</script>
